const teamsByYear = {
    "2008": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Atlanta Thrashers",
            "code": "ATL"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Phoenix Coyotes",
            "code": "PHX"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        }
    ],
    "2009": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Atlanta Thrashers",
            "code": "ATL"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Phoenix Coyotes",
            "code": "PHX"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        }
    ],
    "2010": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Atlanta Thrashers",
            "code": "ATL"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Phoenix Coyotes",
            "code": "PHX"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        }
    ],
    "2011": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Phoenix Coyotes",
            "code": "PHX"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2012": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Phoenix Coyotes",
            "code": "PHX"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2013": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Phoenix Coyotes",
            "code": "PHX"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2014": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Arizona Coyotes",
            "code": "ARI"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2015": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Arizona Coyotes",
            "code": "ARI"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2016": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Arizona Coyotes",
            "code": "ARI"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2017": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Arizona Coyotes",
            "code": "ARI"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Vegas Golden Knights",
            "code": "VGK"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2018": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Arizona Coyotes",
            "code": "ARI"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Vegas Golden Knights",
            "code": "VGK"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2019": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Arizona Coyotes",
            "code": "ARI"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Vegas Golden Knights",
            "code": "VGK"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2020": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Arizona Coyotes",
            "code": "ARI"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Vegas Golden Knights",
            "code": "VGK"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2022": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Arizona Coyotes",
            "code": "ARI"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "Seattle Kraken",
            "code": "SEA"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Vegas Golden Knights",
            "code": "VGK"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2021": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Arizona Coyotes",
            "code": "ARI"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "Seattle Kraken",
            "code": "SEA"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Vegas Golden Knights",
            "code": "VGK"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2023": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Arizona Coyotes",
            "code": "ARI"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "Seattle Kraken",
            "code": "SEA"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Vegas Golden Knights",
            "code": "VGK"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2024": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "Seattle Kraken",
            "code": "SEA"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Utah Hockey Club",
            "code": "UTA"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Vegas Golden Knights",
            "code": "VGK"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
    "2025": [
        {
            "name": "Anaheim Ducks",
            "code": "ANA"
        },
        {
            "name": "Boston Bruins",
            "code": "BOS"
        },
        {
            "name": "Buffalo Sabres",
            "code": "BUF"
        },
        {
            "name": "Calgary Flames",
            "code": "CGY"
        },
        {
            "name": "Carolina Hurricanes",
            "code": "CAR"
        },
        {
            "name": "Chicago Blackhawks",
            "code": "CHI"
        },
        {
            "name": "Colorado Avalanche",
            "code": "COL"
        },
        {
            "name": "Columbus Blue Jackets",
            "code": "CBJ"
        },
        {
            "name": "Dallas Stars",
            "code": "DAL"
        },
        {
            "name": "Detroit Red Wings",
            "code": "DET"
        },
        {
            "name": "Edmonton Oilers",
            "code": "EDM"
        },
        {
            "name": "Florida Panthers",
            "code": "FLA"
        },
        {
            "name": "Los Angeles Kings",
            "code": "LAK"
        },
        {
            "name": "Minnesota Wild",
            "code": "MIN"
        },
        {
            "name": "Montreal Canadiens",
            "code": "MON"
        },
        {
            "name": "Nashville Predators",
            "code": "NSH"
        },
        {
            "name": "New Jersey Devils",
            "code": "NJD"
        },
        {
            "name": "New York Islanders",
            "code": "NYI"
        },
        {
            "name": "New York Rangers",
            "code": "NYR"
        },
        {
            "name": "Ottawa Senators",
            "code": "OTT"
        },
        {
            "name": "Philadelphia Flyers",
            "code": "PHI"
        },
        {
            "name": "Pittsburgh Penguins",
            "code": "PIT"
        },
        {
            "name": "San Jose Sharks",
            "code": "SJS"
        },
        {
            "name": "Seattle Kraken",
            "code": "SEA"
        },
        {
            "name": "St. Louis Blues",
            "code": "STL"
        },
        {
            "name": "Tampa Bay Lightning",
            "code": "TBL"
        },
        {
            "name": "Toronto Maple Leafs",
            "code": "TML"
        },
        {
            "name": "Utah Hockey Club",
            "code": "UTA"
        },
        {
            "name": "Vancouver Canucks",
            "code": "VAN"
        },
        {
            "name": "Vegas Golden Knights",
            "code": "VGK"
        },
        {
            "name": "Washington Capitals",
            "code": "WAS"
        },
        {
            "name": "Winnipeg Jets",
            "code": "WIN"
        }
    ],
}

export default teamsByYear;